import _map from "lodash/map"
import _get from "lodash/get"
import _groupBy from "lodash/groupBy"
import {
  getProductKey,
  getContractKey,
  getBalanceKey,
  getServiceKey
} from "services/utils/generateBase64"
import {
  PRODUCT_SYSTEMS,
  PRODUCTSTATUS
} from "services/state/billing/constants"

export const groupByProductLine = (products, documentNumber) => {
  const groupedByProductLine = _groupBy(products, (product) => {
    const lineOfBusiness = _get(
      product,
      "productLine.name",
      product.lineOfBusiness
    )
    return lineOfBusiness
  })

  return _map(Object.keys(groupedByProductLine), (unused, i) => {
    return {
      lineOfBusiness: Object.keys(groupedByProductLine)[i],
      products: productsAdapter(
        groupedByProductLine[Object.keys(groupedByProductLine)[i]],
        documentNumber
      )
    }
  })
}

const productsAdapter = (products, documentNumber) => {
  return _map(products, (product) => {
    let canceledCustomer = _get(product, "canceledCustomer", true)

    if (product.productStatus === PRODUCTSTATUS.INATIVO) {
      canceledCustomer = false
    }

    const agreementId = _get(
      product,
      "agreementId",
      _get(product, "assetId", "")
    )
    const assetId = _get(product, "assetId", "")
    const assetFullName = _get(
      product,
      "assetFullName",
      _get(product, "productFullName", "")
    )
    const assetNumber = _get(product, "assetNumber", "")
    const assetTag = _get(product, "assetTag", "")
    const billingAccountNumber = _get(
      product,
      "accountNumber",
      _get(product, "billingAccount", _get(product, "billingAccountNumber", ""))
    )
    const billingModalityId = _get(product, "billingModalityId", "")
    const billingModalityName = _get(product, "billingModalityName", "")
    const circuit = _get(product, "assetTag", _get(product, "circuit", ""))
    const cnlAcronym = _get(
      product,
      "locality.code",
      _get(product, "cnlAcronym", "")
    )
    const description = _get(product, "description", "")
    const installedAt = _get(product, "instaledAt", "")
    const localityName = _get(product, "locality.name", "")
    const packageAssetId = _get(product, "packageAssetId", "")
    const paymentMode = _get(product, "paymentMode", "")
    const productId = _get(
      product,
      "product.id",
      _get(product, "productId", "")
    )
    const productName = _get(
      product,
      "product.name",
      _get(product, "productName", "")
    )
    const productStatus =
      PRODUCTSTATUS[_get(product, "status", _get(product, "productStatus", ""))]
    const productSystem = _get(
      product,
      "productSystem",
      PRODUCT_SYSTEMS.ALGAR_CRM
    )
    const purchaseAt = _get(product, "purchaseAt", "")
    const sellPriceValue = _get(product, "sellPriceValue", "")
    const serviceId = _get(product, "assetTag", _get(product, "serviceId", ""))
    const subStatus = _get(product, "subStatus", "")
    const type = _get(product, "type", "")
    const balanceKey = getBalanceKey({ documentNumber, serviceId })
    const contractKey = getContractKey({
      documentNumber,
      productId,
      agreementId,
      serviceId
    })
    const productKey = getProductKey({
      documentNumber,
      productId,
      agreementId,
      serviceId
    })
    const serviceKey = getServiceKey({ serviceId })

    return {
      ...product,
      assetId,
      agreementId,
      assetFullName,
      assetNumber,
      assetTag,
      balanceKey,
      billingAccountNumber,
      billingModalityId,
      billingModalityName,
      canceledCustomer,
      circuit,
      cnlAcronym,
      contractKey,
      description,
      installedAt,
      localityName,
      noc: false,
      packageAssetId,
      paymentMode,
      productId,
      productKey,
      productName,
      productStatus,
      productSystem,
      purchaseAt,
      sellPriceValue,
      serviceId,
      serviceKey,
      subStatus,
      type
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/state/billing/adapter.js